import { Badges, H5, H6, P } from "../../../../AbstractElements";
import { MyResolutions, MyResolutionsFor2023, ResolutionText, Resolutions } from "../../../../Constant";

const ResolutionTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-movie bg-danger">
        <i className="icon-agenda" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="warning">{Resolutions}</Badges>
        </div>
        <H5 className="m-0 vertical-timeline-element-subtitle">{MyResolutionsFor2023}</H5>
        <P className="mb-0">{ResolutionText}</P>
        <div className="time-content pt-2">
          <i className="icon-android"></i>
          <H6>{MyResolutions}</H6>
        </div>
        <span className="cd-date">December 31 2022 </span>
      </div>
    </div>
  );
};
export default ResolutionTimeline;
